import { render } from "./ViewerApp.vue?vue&type=template&id=6530daf5"
import script from "./ViewerApp.vue?vue&type=script&lang=js"
export * from "./ViewerApp.vue?vue&type=script&lang=js"

import "./ViewerApp.vue?vue&type=style&index=0&id=6530daf5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__